module.exports = __webpack_public_path__ + "media/src/images/site-top/article2-e0cb9014b3721368b5c3a444752f0bfa.jpg";